<template>
  <LoaderContent ref="loader">
  <div class="main-page" >
    <div class="main-wallet" v-for="store in stores" :key="store.id">
      <div>
        <div class="d-flex justify-content-between align-items-center main-wallet__header">
          <div class="main-wallet__title">
            {{store.name}} ({{store.currency}})
          </div>
          <div class="main-wallet__percents-list d-flex justify-content-end align-items-end">
            <div class="main-wallet__percents-item text-capitalize-first"><b>{{ helper.trans(`direction.in`) }}:</b> <span>{{numberFormatter.formatNumber(store.payInFee * 100, 2)}}%</span></div>
            <div class="main-wallet__percents-item text-capitalize-first"><b>{{ helper.trans(`direction.out`) }}:</b> <span>{{numberFormatter.formatNumber(store.payOutFee * 100, 2)}}%</span></div>
          </div>
        </div>
        <div class="main-wallet__top main-wallet__top__store" v-for="msAccount in store.accounts">
          <div class="main-wallet__main-info">
            <div class="main-wallet__icon_small">
              <img  :src="helper.currencyIcon(msAccount.account.currency)">
            </div>
            <div class="main-wallet__info">
              <div class="main-wallet__sum main-wallet__sum__small">
                <span>{{ numberFormatter.formatNumber(msAccount.account.sumWithoutInsurance) }}</span> {{msAccount.account.currency}}
              </div>
              <div class="main-wallet__number-title text-capitalize-first">
                {{ $t('dashboard.on_hold') }}: {{ numberFormatter.formatNumber(msAccount.account.frozenSum) }} {{ msAccount.account.sum.currency }}
              </div>

              <div class="main-wallet__wallet" v-if="msAccount.account._wallet">
                      <span class="main-wallet__wallet-address for-copy">
                          {{ msAccount.account._wallet ? truncateAddress(msAccount.account._wallet.address) : '' }}
                      </span>
                <span>(USDT TRC20)</span>
                <CopyButton :value="msAccount.account._wallet?.address"></CopyButton>
              </div>
            </div>
          </div>
          <div class="main-wallet__controls">
            <a v-if="isMerchant" href="#" @click.prevent="showWithdrawal(msAccount.account)" class="btn main-wallet__btn"><span class="text-capitalize-first">{{ $t('button.withdraw')}}</span></a>
            <a href="#" @click.prevent="showHistory(msAccount.account)" class="btn main-wallet__btn"><span class="text-capitalize-first">{{ $t('button.history')}}</span></a>
          </div>
        </div>
      </div>
    </div>

  </div>
  </LoaderContent>
  <AccountOperationPopup ref="accountOperationPopup"/>
  <WithdrawalPopup ref="withdrawalPopup"/>
</template>
<script lang="ts">
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {$t, helper, truncateAddress} from "@/service/CommonHelper";
import {useStore} from "vuex";
import AccountDTO from "@/models/AccountDTO";
import {api} from "@/service/APIClient";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import AccountOperationPopup from "@/apps/public/components/AccountOperationPopup.vue";
import WithdrawalPopup from "@/apps/public/components/WithdrawalPopup.vue";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import {Dictionary} from "@/types";
import WalletDTO from "@/models/WalletDTO";
import PaginationDTO from '@/models/PaginationDTO';
import WalletsRequestDTO from "@/models/request/WalletsRequestDTO";

export default defineComponent({
  name: 'TraderDashboard',
  methods: {$t},
  components: {
    WithdrawalPopup,
    CopyButton,
    AccountOperationPopup,
    LoaderContent
  },
  setup: function () {
    const accountOperationPopup = ref<InstanceType<typeof AccountOperationPopup> | null>(null)
    const withdrawalPopup = ref<InstanceType<typeof WithdrawalPopup> | null>(null)
    const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
    const store = useStore()

    const state = reactive({
      stores: [] as MerchantStoreDTO[],
    });

    const loadStores = async () => {
      loader.value?.load(async () => {
        state.stores = await api.storesAll();
        loadWallets();
      })
    }

    const loadWallets = async () => {
      let accountIds = []
      for (const store of state.stores) {
        for (const msAccount of store.accounts) {
          accountIds.push(msAccount.account.id)
        }
      }
      const wallets = {} as Dictionary<WalletDTO>
      for (const resp of (await api.wallets({limit: accountIds.length, offset: 0} as PaginationDTO, {accountIds} as WalletsRequestDTO)).items) {
        if (resp.accountId) {
          wallets[resp.accountId] = resp
        }
      }

      for (const store of state.stores) {
        for (const msAccount of store.accounts) {
          msAccount.account._wallet = wallets[msAccount.account.id] ?? null
        }
      }
    }

    onMounted(async () => {
      loadStores();
    });

    const showWithdrawal = (account: AccountDTO) => {
      withdrawalPopup.value?.show(account)
    }

    const showHistory = (account: AccountDTO) => {
      accountOperationPopup.value?.show(account)
    }



    return {
      ...toRefs(state),
      truncateAddress,
      showHistory,
      showWithdrawal,
      withdrawalPopup,
      accountOperationPopup,
      numberFormatter,
      store,
      loader,
      helper,
      isMerchant: computed(() => store.getters.isMerchant),
    }
  }
})
</script>
